/** Formats a decimal amount string in the user's locale, with the currency when known. */
export function formatMoney(amount: string, currency: string | null, locale: string): string {
    const value = Number(amount);
    return currency === null
        ? new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
        : new Intl.NumberFormat(locale, { style: "currency", currency }).format(value);
}

/** The change from the previous amount, in percent, or `null` when there was nothing before. */
export function changePercent(amount: string, previousAmount: string): number | null {
    const previous = Number(previousAmount);
    return previous === 0 ? null : ((Number(amount) - previous) / previous) * 100;
}

/** Formats a timestamp in the user's locale and time zone. */
export function formatTimestamp(timestamp: string, locale: string): string {
    return new Date(timestamp).toLocaleString(locale);
}

/** Formats a zoneless `YYYY-MM` month in the user's locale. */
export function formatMonth(month: string, locale: string): string {
    const [year, monthNumber] = month.split("-").map(Number) as [number, number];
    return new Intl.DateTimeFormat(locale, { year: "numeric", month: "long", timeZone: "UTC" }).format(
        new Date(Date.UTC(year, monthNumber - 1, 1)),
    );
}
